<!-- 下载页面 -->
<template>
    <div class="download">
        <div class="dl-backdrop" aria-hidden="true">
            <span class="dl-backdrop__stripe dl-backdrop__stripe--1"></span>
            <span class="dl-backdrop__stripe dl-backdrop__stripe--2"></span>
        </div>
        <div class="downHead">
            <div class="downHead__frame">
                <img class="downloadLogo" src="@/assets/download/downloadLogo.png" alt="">
            </div>
            <div class="title">艺选臻品</div>
            <div class="desc">yixuanzhenpinAPP</div>
            <p class="downHead__hint">选择与您设备相符的版本安装</p>
        </div>
        <div class="downBtn">
            <div :class="downAddress.userAgent == userAgent.IOS ? 'item' : 'active item'" @click="goDownload">
                <span class="downBtn__label">IOS版下载</span>
            </div>
            <div :class="downAddress.userAgent == userAgent.ANDROID ? 'item' : 'active item'" @click="goDownload">
                <span class="downBtn__label">安卓版下载</span>
            </div>
        </div>
        <div class="wechatBox" v-if="isWechat">
            <div class="wechatBox__panel">
                <img class="wechatBox__gif" src="@/assets/download/dynamicImg.gif" alt="">
                <div class="wechatBox__text">
                    <p>请点击左上角“…”在浏览器打开此页面。</p>
                    <p>(备注：苹果手机用户请在Safari中打开此页面）</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, reactive, onMounted , getCurrentInstance } from 'vue';
import { getUserAgent } from '@/utils/index';
import { userAgent } from '@/utils/types';
import storage from 'store';
import { ACCESS_TOKEN , BRANDID } from '@/utils/types';
import { NavBar } from 'vant';
export default {
    components:{
        [NavBar.name]:NavBar,
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const downAddress = reactive({
            android: undefined,
            ios: undefined,
            userAgent: undefined,
        })
        const isWechat = ref(false)
        const brandId = proxy.$route.params.brandId
        console.log(proxy.$route.params)
        // 获取当前用户终端类型
        downAddress.userAgent = getUserAgent()
        if(downAddress.userAgent == userAgent.WECHAT){
            isWechat.value = true
            return {
                userAgent,
                downAddress,
                goDownload,
                isWechat,
            }
        }
        // 获取系统的token
        function getToken(){
            proxy.$http.brandApi.getToken(brandId)
            .then(res=>{
                if(res.success){
                    storage.set(ACCESS_TOKEN,res[ACCESS_TOKEN], res.expires_in)
                    proxy.$http.loginApi.getAppDownload(1)
                    .then(res=>{
                        console.log(res)
                        if(res.data.length == 0){
                            proxy.$toast({position: 'bottom',message:'暂未获取到下载地址！'})
                        }else{
                            downAddress.android = res.data[0].externalDownloadUrl
                            downAddress.ios = res.data[0].iosExternalDownloadUrl
                        }
                    })
                }
            })
        }
        // 跳转下载页面
        function goDownload(){
            switch(downAddress.userAgent){
                case userAgent.ANDROID:
                    if(downAddress.android){
                        window.location.href = downAddress.android;
                    }else{
                        proxy.$toast({position: 'bottom',message: '暂未获取到下载链接！'})
                    }
                    break;
                case userAgent.IOS:
                    if(downAddress.ios){
                        window.location.href = downAddress.ios;
                    }else{
                        proxy.$toast({position: 'bottom',message: '暂未获取到下载链接！'})
                    }
                    break;
                default:
                    proxy.$toast({position: 'bottom',message: '暂未获取到当前终端设备的型号！'})
                    break;
            }
        }
        // 页面加载后获取APP的下载地址
        onMounted(()=>{
            getToken()
        })

        const onClickLeft = () => history.back();
        return {
            userAgent,
            downAddress,
            goDownload,
            isWechat,
            onClickLeft,
        }
    }
}

</script>
<style scoped>
/* 与注册页同系暖色纸感，但版式改为「卡片 + 斜纹底 + 双列按钮」 */
.download{
    --dl-ink: #1c1917;
    --dl-muted: #57534e;
    --dl-paper: #fffefb;
    --dl-teal: #0f766e;
    --dl-amber: #d97706;
    --yl-text: var(--dl-ink);
    --yl-muted: var(--dl-muted);
    min-height: 100vh;
    font-size: 15px;
    color: var(--dl-ink);
    font-weight: 500;
    background:
        linear-gradient(135deg, #fff7ed 0%, #ecfdf5 38%, #f5f0e8 100%);
    padding: 28px 18px 32px;
    padding-top: max(28px, env(safe-area-inset-top));
    box-sizing: border-box;
    font-family: ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif;
    position: relative;
    overflow-x: hidden;
}
.dl-backdrop{
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    overflow: hidden;
}
.dl-backdrop__stripe{
    position: absolute;
    width: 140%;
    height: 48px;
    left: -20%;
    transform: rotate(-8deg);
    opacity: 0.07;
}
.dl-backdrop__stripe--1{
    top: 18%;
    background: repeating-linear-gradient(
        90deg,
        var(--dl-teal) 0,
        var(--dl-teal) 12px,
        transparent 12px,
        transparent 24px
    );
}
.dl-backdrop__stripe--2{
    bottom: 22%;
    background: repeating-linear-gradient(
        90deg,
        var(--dl-amber) 0,
        var(--dl-amber) 10px,
        transparent 10px,
        transparent 22px
    );
    transform: rotate(5deg);
}
.downHead{
    width: min(440px, 100%);
    margin: 0 auto;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    background: var(--dl-paper);
    border-radius: 24px 6px 24px 6px;
    padding: 28px 22px 24px;
    border: 1px solid rgba(28, 25, 23, 0.09);
    box-shadow:
        8px 8px 0 rgba(15, 118, 110, 0.15),
        0 20px 40px rgba(28, 25, 23, 0.07);
    position: relative;
    z-index: 1;
}
.downHead::after{
    content: "";
    position: absolute;
    top: 20px;
    right: 18px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, #fde68a, transparent 70%);
    opacity: 0.5;
    pointer-events: none;
}
.downHead__frame{
    width: 132px;
    height: 132px;
    border-radius: 50%;
    margin: 0 auto 16px;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #f0fdfa, #fffbeb);
    border: 3px solid var(--dl-teal);
    box-shadow: inset 0 2px 0 rgba(255,255,255,0.8);
}
.downloadLogo{
    width: 96px;
    height: auto;
    filter: none;
}
.title{
    font-family: "Noto Serif SC", "Songti SC", Georgia, serif;
    font-size: 24px;
    font-weight: 700;
    color: var(--dl-ink);
    letter-spacing: 0.08em;
    width: 100%;
    text-align: center;
}
.desc{
    font-size: 11px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--dl-muted);
    margin-top: 8px;
    width: 100%;
    text-align: center;
}
.downHead__hint{
    margin: 16px 0 0;
    font-size: 13px;
    color: var(--dl-muted);
    line-height: 1.5;
    text-align: center;
    width: 100%;
}
.downBtn{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    width: min(440px, 100%);
    margin: 20px auto 0;
    position: relative;
    z-index: 1;
}
@media (max-width: 360px){
    .downBtn{
        grid-template-columns: 1fr;
    }
}
.item{
    color: #fff;
    min-height: 52px;
    border-radius: 4px 18px 4px 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--dl-teal);
    border: 2px solid #0f766e;
    cursor: pointer;
    user-select: none;
    transition: transform 160ms ease, box-shadow 160ms ease, background-color 160ms ease, color 160ms ease;
    box-shadow: 0 3px 0 #115e59;
    position: relative;
    overflow: visible;
}
.item:active{
    transform: translateY(2px);
    box-shadow: 0 0 0 #115e59;
}
.downBtn__label{
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.06em;
}
.download .active{
    background: #fff;
    color: var(--dl-teal);
    border: 2px dashed rgba(15, 118, 110, 0.45);
    box-shadow: none;
    font-weight: 600;
}

.wechatBox{
    height: 100vh;
    width: 100vw;
    position: fixed;
    inset: 0;
    background: rgba(28, 25, 23, 0.88);
    backdrop-filter: blur(6px);
    color: #fafaf9;
    z-index: 9999;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 24px 16px;
    box-sizing: border-box;
}
.wechatBox__panel{
    margin-top: 12vh;
    max-width: 340px;
    background: var(--dl-paper);
    color: var(--dl-ink);
    border-radius: 8px 24px 8px 24px;
    padding: 20px 18px 22px;
    border: 2px solid rgba(15, 118, 110, 0.25);
    box-shadow: 12px 12px 0 rgba(15, 118, 110, 0.2);
}
.wechatBox__gif{
    display: block;
    width: 100%;
    max-width: 280px;
    margin: 0 auto 16px;
    border-radius: 8px;
}
.wechatBox__text{
    font-size: 14px;
    line-height: 1.65;
    text-indent: 0;
}
.wechatBox__text p{
    margin: 0 0 8px;
}
.wechatBox__text p:last-child{
    margin-bottom: 0;
}

.download /deep/ .van-nav-bar__content{
    background: #fffefb;
}
.download /deep/ .van-badge__wrapper{
    color: var(--dl-ink);
}
.download /deep/ .van-nav-bar__title{
    color: var(--dl-ink);
}

@media (prefers-reduced-motion: reduce){
    .item{
        transition: none !important;
    }
}
</style>